export const environment = {
  production: true,
  apiUrl: '/api',
  apiKey: 'fb0cf124293b0dca81ae8c5a4f6682312892c15288ed59eb6a8209627cf19583',
  pythonUrl: window.location.origin + '/ai',
};
